import type { Dialog as BaseDialog } from '@base-ui/react';

import type { ForumAuthor } from '~/api/forum/types';

import { Dialog } from '~/components';
import { CommunityProfileDialog } from '~/features/community';

import { ModeratorProfileDialog } from './ModeratorProfileDialog';

type Props = {
  handle: BaseDialog.Handle<ForumAuthor>;
};

/**
 * A single author dialog shared by a list of forum posts.
 * The profile dialog is only mounted while it's open, so a post preview doesn't fetch its author's community profile on render.
 */
export const ForumAuthorDialog = ({ handle }: Props) => {
  return (
    <Dialog.Root handle={handle}>
      {({ payload: author }) =>
        author !== undefined &&
        (author.isModerator ? (
          <ModeratorProfileDialog moderator={author} />
        ) : (
          <CommunityProfileDialog communityProfileId={author.communityProfileId} />
        ))
      }
    </Dialog.Root>
  );
};
